// @core/api/endpoints/tenant/add_tenant_member.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddTenantMemberRequest,
  TenantMemberResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Add member to tenant
 * Adds a user as a member of the tenant with the specified role. The user will gain access to tenant resources according to their assigned role.
 */
export async function AddTenantMember(
  tenant_id: string,
  data: AddTenantMemberRequest,
  options?: RequestOptions
): Promise<TenantMemberResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/members`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.post<TenantMemberResponse>(requestPath, data, requestOptions);
}
